module.exports = __webpack_public_path__ + "img/background.c4b601a4.svg";